
import CryptoJS from 'crypto-js';

const ProcessKey: string = process.env.NEXT_PUBLIC_CRYPTO_KEY || 'sKey';

export function saveDataToSessionStorage(key: string, value: any) {
    const jsonString = JSON.stringify(value);
    const encrypted = CryptoJS.AES.encrypt(jsonString, ProcessKey).toString();
    localStorage.setItem(key, encrypted);
}

export function removeDataFromSessionStorage(key: string) {
    if (!key) return null;
    localStorage.removeItem(key);
}

export function removeAllDataFromSessionStorage() {
    localStorage.clear();
}

export function getDataFromSessionStorage(key: string | null): any {
    try {
        if (!key) return null;
        const item: string | null = localStorage.getItem(key);
        if (!item) return null;
        const bytes = CryptoJS.AES.decrypt(item, ProcessKey);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        return decrypted ? JSON.parse(decrypted) : null;
    } catch {
        return null;
    }
}
